import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import classNames from 'classnames';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import AppBar from "@material-ui/core/AppBar";

const styles = theme => ({
    appBar: {
        position: "relative"
    },
    flex: {
        flex: 1
    },
    paddingTopContent: {
        paddingTop: "2em"
    },
    fullHeight:{
        minHeight: 'calc(100% - 20px)',
        maxHeight: 'calc(100% - 20px)',
    }
});

function CloseButtonDialog(props) {
    const { classes } = props;

    return (
        <div>
            <Dialog open={props.open} onClose={props.onClose} classes={{paper:props.fullHeight?classes.fullHeight:null}} fullWidth={props.fullWidth ? props.fullWidth : false} maxWidth={props.size ? props.size : "lg"} fullScreen={props.fullScreen ? props.fullScreen : false}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" color={props.color ? props.color : "inherit"} className={classes.flex}>
                            {props.title}
                        </Typography>
                        {
                            props.closeButton ?
                                <IconButton color={props.color ? props.color : "inherit"} onClick={props.onClose} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                : null
                        }
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.paddingTopContent}>
                    {props.content}
                </DialogContent>
                <DialogActions>
                    {props.footer}
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withStyles(styles)(CloseButtonDialog);